/** Loads Google's Maps JavaScript API once (with the key from the server), then its libraries. */
let loading: Promise<void> | null = null;

export function loadGoogleMaps(apiKey: string): Promise<void> {
  if ((window as { google?: { maps?: { importLibrary?: unknown } } }).google?.maps?.importLibrary) return Promise.resolve();
  if (loading) return loading;
  loading = new Promise<void>((resolve, reject) => {
    const callback = "__nmtGoogleMapsReady";
    (window as unknown as Record<string, () => void>)[callback] = () => resolve();
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?${new URLSearchParams({ key: apiKey, v: "weekly", loading: "async", callback })}`;
    script.async = true;
    script.onerror = () => {
      loading = null;
      reject(new Error("Couldn't load Google Maps. Check your connection and try again."));
    };
    document.head.append(script);
  });
  return loading;
}

/** Google calls this when the key is wrong or not allowed on this address. */
export function onGoogleMapsAuthFailure(fn: () => void) {
  (window as unknown as { gm_authFailure?: () => void }).gm_authFailure = fn;
}
